import React, { FC, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';

import cn from 'classnames';
import { Button, LoaderSpinner } from 'components/UtilElements';
import { API, request } from 'redux/api';
import { RootState } from 'redux/reducers';
import { ROUTES } from 'routes';

interface CourseApprovalRequestResponse extends MessageResponse {
  displayMessage: string;
}

const sendApprovalRequest = () => {
  return request<CourseApprovalRequestResponse>({
    method: 'POST',
    url: API.COURSE_REQUEST_APPROVAL,
  });
};

const mapState = ({ getAccess }: RootState) => {
  return { accessData: getAccess };
};

type Props = ReturnType<typeof mapState>;

const CourseApproval: FC<Props> = ({ accessData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');

  const year = useMemo(() => new Date().getFullYear(), []);

  if (!accessData) return null;

  if (message) {
    return (
      <Redirect
        to={{
          pathname: ROUTES.MESSAGE_PAGE,
          state: {
            code: 'SUCCESS',
            message,
          },
        }}
      />
    );
  }

  return (
    <div className={cn('page', 'auth')}>
      <div className='auth__container'>
        <h2 className='auth__title'>Request Course Approval</h2>
        <div className='auth__panel'>
          <p className='auth__message'>
            <strong>
              {accessData.courseDetails.code}: {accessData.courseDetails.title}
            </strong>{' '}
            is awaited for admin approval
          </p>
          <div className='auth__action-container'>
            <Button
              type='ghost'
              selector={cn('btn-primary', 'auth__action')}
              onRipple={async () => {
                setIsLoading(true);
                const { displayMessage } = await sendApprovalRequest();
                setMessage(displayMessage);
              }}
            >
              {isLoading ? <LoaderSpinner /> : 'REQUEST ACCESS'}
            </Button>
          </div>
        </div>
        <div className='auth__footer'>&#9400; {year}, Acetone Designs Private Limited</div>
      </div>
    </div>
  );
};

export default connect(mapState)(CourseApproval);
